var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "solutions_svg_icon_group",
    "data-name": "solutions svg icon group",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38015",
    "data-name": "Rectangle 38015",
    width: 62,
    height: 62,
    transform: "translate(0.309 0.309)",
    fill: "none",
    stroke: "#003182",
    strokeWidth: 4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Primary_Button",
    "data-name": "Rectangle/Primary Button",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(60 49) rotate(180)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solutions_svg_icon",
    "data-name": "solutions svg icon",
    transform: "translate(-0.309 -0.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solutions_svg_icon-2",
    "data-name": "solutions svg icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4606",
    "data-name": "Path 4606",
    d: "M25.681,12.218A8.462,8.462,0,1,1,17.22,3.757,8.461,8.461,0,0,1,25.681,12.218Z",
    transform: "translate(14.089 6.045)",
    fill: "none",
    stroke: "#003182",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4607",
    "data-name": "Path 4607",
    d: "M19.681,22.218a8.462,8.462,0,1,1-8.461-8.461A8.461,8.461,0,0,1,19.681,22.218Z",
    transform: "translate(4.435 22.136)",
    fill: "none",
    stroke: "#003182",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4608",
    "data-name": "Path 4608",
    d: "M31.681,22.218a8.462,8.462,0,1,1-8.461-8.461A8.461,8.461,0,0,1,31.681,22.218Z",
    transform: "translate(23.743 22.136)",
    fill: "none",
    stroke: "#003182",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions .66d0798befdeec3222924c87defb1f1a.svg";
export { ForwardRef as ReactComponent };